import { z } from 'zod';
import { productFilterSchema } from './productFilterSchema';

export const getFilterSchema = z.object({
    category: z.string().uuid().nullable(),
    list: z.string().uuid().nullable(),
    search: z.string().default(''),
    filter: productFilterSchema.optional(),
});

export type GetFilterSchema = z.infer<typeof getFilterSchema>;
